import { api } from "@/lib/api/client";
import type {
  AuditListResponse,
  NexusRoleListItem,
  PermissionsCatalogResponse,
  RolesListResponse,
  UsersListResponse,
} from "./types";

// Prefix /api/nexus (ver app.ts:629).
const BASE = "/api/nexus/control";

export const controlApi = {
  // Users
  listUsers: async (params: { q?: string; roleSlug?: string }): Promise<UsersListResponse> => {
    const { data } = await api.get<UsersListResponse>(`${BASE}/users`, { params });
    return data;
  },
  grantRole: async (email: string, roleSlug: string): Promise<void> => {
    await api.post(`${BASE}/users/grant`, { email, roleSlug });
  },
  revokeRole: async (userId: number, roleSlug: string): Promise<void> => {
    await api.delete(`${BASE}/users/${userId}/roles/${encodeURIComponent(roleSlug)}`);
  },

  // Roles
  listRoles: async (): Promise<RolesListResponse> => {
    const { data } = await api.get<RolesListResponse>(`${BASE}/roles`);
    return data;
  },
  createRole: async (body: {
    slug: string;
    name: string;
    description?: string;
    permissions: string[];
  }): Promise<NexusRoleListItem> => {
    const { data } = await api.post<{ success: boolean; role: NexusRoleListItem }>(
      `${BASE}/roles`,
      body,
    );
    return data.role;
  },
  updateRole: async (
    id: number,
    body: { name?: string; description?: string; permissions?: string[] },
  ): Promise<NexusRoleListItem> => {
    const { data } = await api.patch<{ success: boolean; role: NexusRoleListItem }>(
      `${BASE}/roles/${id}`,
      body,
    );
    return data.role;
  },
  deleteRole: async (id: number): Promise<void> => {
    await api.delete(`${BASE}/roles/${id}`);
  },
  permissionsCatalog: async (): Promise<PermissionsCatalogResponse> => {
    const { data } = await api.get<PermissionsCatalogResponse>(
      `${BASE}/permissions-catalog`,
    );
    return data;
  },

  // Audit
  listAudit: async (params: {
    q?: string;
    action?: string;
    actorUserId?: number;
    targetType?: string;
    page?: number;
    pageSize?: number;
  }): Promise<AuditListResponse> => {
    const { data } = await api.get<AuditListResponse>(`${BASE}/audit`, { params });
    return data;
  },
};
